import React, { FC, useCallback, useState } from "react";
import { Button, DatePickerInput } from "@shared/components";
import { SensorDataSession } from "@shared/models";
import { DATE_FORMAT } from "@shared/constants";
import "./index.scss";
import { formatDateToTz } from "@shared/utils";

interface SensorDataSessionDateRangeModalProps {
  session: SensorDataSession;
  onClose: () => void;
  onSubmit: (startDate: string, endDate: string) => void;
}

const SensorDataSessionDateRangeModal: FC<SensorDataSessionDateRangeModalProps> = ({ onClose, onSubmit, session }) => {
  const [startDate, setStartDate] = useState<Date | null>(session.station_start_date);
  const [endDate, setEndDate] = useState<Date | null>(session.station_end_date);

  const handleSubmit = useCallback(() => {
    if (startDate && endDate) {
      onSubmit(formatDateToTz(startDate, session.station_timezone), formatDateToTz(endDate, session.station_timezone));
      onClose();
    }
  }, [onClose, onSubmit, startDate, endDate, session.station_timezone]);

  return (
    <div className="download-csv-file-modal modal-content-wrapper">
      <div className="modal-heading">Select Date Range</div>
      <div className="modal-content">
        <div className="session-station-date-range-modal">
          <div className="session-station-date-range-item">
            <DatePickerInput
              placement="auto"
              labelTitle={`Start (${session.station_timezone})`}
              onChange={setStartDate}
              name="station_start_date"
              value={startDate}
              format={DATE_FORMAT.DATE_PICKER}
            />
          </div>
          <div className="session-station-date-range-item">
            <DatePickerInput
              placement="auto"
              labelTitle={`End (${session.station_timezone})`}
              onChange={setEndDate}
              value={endDate}
              name="station_end_date"
              format={DATE_FORMAT.DATE_PICKER}
            />
          </div>
        </div>
      </div>
      <div className="modal-actions">
        <div>
          <Button appearance="subtle" className="subtle auto-width" onClick={onClose}>
            Cancel
          </Button>
          <Button
            type="submit"
            className="blue auto-width"
            onClick={() => handleSubmit()}
            disabled={!(startDate && endDate)}
          >
            Download
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SensorDataSessionDateRangeModal;
